<script lang="ts">
  import Card from '../elements/Card.svelte';
  import InlineSvg from '../elements/InlineSvg.svelte';

  let items = [
    {
      title: 'Siter.io',
      category: 'Builders',
      image: '/img/mock-siterio.png',
      description: 'Freehand design tool, no-code website builder',
    },
    {
      title: 'Proudlist',
      category: 'Productivity',
      image: '/img/mock-proudlist.png',
      description: 'Build your own CRM, in minutes',
    },
    {
      title: 'Siter.io',
      category: 'Builders',
      image: '/img/mock-siterio.png',
      description: 'Freehand design tool, no-code website builder',
    },
    {
      title: 'Proudlist',
      category: 'Productivity',
      image: '/img/mock-proudlist.png',
      description: 'Build your own CRM, in minutes',
    },
    {
      title: 'Siter.io',
      category: 'Builders',
      image: '/img/mock-siterio.png',
      description: 'Freehand design tool, no-code website builder',
    },
    {
      title: 'Proudlist',
      category: 'Productivity',
      image: '/img/mock-proudlist.png',
      description: 'Build your own CRM, in minutes',
    },
  ];
</script>

<div class="ns-container">
  <div class="newsletter">
    <div class="ns-header">
      <div class="mail-info">
        <div class="avatar">
          <InlineSvg src="/img/the-stocks-mini.svg" />
        </div>
        <div class="title">The Stocks Weekly Issue #10</div>
        <div class="address">The Stocks &lt;hello@thestocks.im&gt;</div>
      </div>
      <div class="subscription">
        <input type="email" placeholder="Enter your email to subscribe" />
        <button type="submit">Subscribe</button>
      </div>
    </div>
    <div class="ns-content">
      <div class="logo">
        <InlineSvg src="/img/the-stocks-v3.svg" width="270px" />
      </div>
      <div class="ns-info">
        <div class="ns-issue" />
        <div class="ns-date" />
      </div>
      <div class="ns-banner">
        <img src="/img/newsletter.png" alt="The Stocks Newsletter" />
      </div>
      <div class="ns-cards">
        {#each items as item}
          <Card>
            <span slot="category">{item.category}</span>
            <span slot="title">{item.title}</span>
            <span slot="description">{item.description}</span>
            <img slot="image" src={item.image} alt={item.title} />
          </Card>
        {/each}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @import '../../styles/mixins';

  .ns-container {
    overflow: overlay;
    width: 100%;
    height: 100%;
    padding: 12px 80px;
    background-color: #ffffff;

    .newsletter {
      max-width: 768px;
      background-color: var(--color-blue-gray--50);
      border-radius: 15px;
      margin: 0 auto;
      overflow: hidden;

      .ns-header {
        display: flex;
        justify-content: space-between;
        background-color: var(--color-blue-gray--100);
        padding: 20px 24px;

        .mail-info {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding-left: 48px;

          .title {
            @include font(Semibold);
            font-size: 14px;
            line-height: 18px;
            color: var(--color-blue-gray--600);
            margin-bottom: 4px;
          }

          .address {
            @include font();
            font-size: 11px;
            line-height: 130%;
            color: var(--color-blue-gray--400);
          }

          .avatar {
            position: absolute;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            border-radius: 50px;
            background-image: linear-gradient(154.98deg, #303d56 6.25%, #272f3f 84.09%);
          }
        }

        .subscription {
          * {
            outline: none;
          }

          position: relative;
          display: flex;
          width: 326px;
          height: 36px;

          input {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: 11px;
            line-height: 16px;
            padding: 10px 12px;
            color: var(--color-blue-gray--800);
            background: var(--color-blue-gray--50);
            border: 1px solid var(--color-blue-gray--200);
            border-radius: 5px;

            &::placeholder {
              color: var(--color-blue-gray--500);
            }
          }

          button {
            position: absolute;
            top: 5px;
            right: 4px;
            display: flex;
            justify-content: center;
            align-items: center;
            border: none;
            cursor: pointer;
            height: 26px;
            font-size: 11px;
            line-height: 130%;
            font-weight: 700;
            padding: 6px 12px;
            color: var(--color-blue-gray--800);
            background-color: #55ecbc;
            border-radius: 5px;

            &:hover {
              opacity: 0.8;
            }
          }
        }
      }

      .ns-content {
        padding: 44px 84px;

        .logo {
          :global(.svg-wrapper svg path) {
            fill: var(--color-blue-gray--800);
          }
        }

        .ns-banner {
          margin-top: 60px;
          img {
            width: 100%;
            object-fit: contain;
          }
        }

        .ns-cards {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(288px, 1fr));
          gap: 24px;
          margin-top: 60px;
        }
      }
    }
  }

  :global(.dark-mode) {
    .ns-container {
      background-color: #101319;

      .newsletter {
        background-color: var(--color-blue-gray--900);

        .ns-header {
          background-color: var(--color-blue-gray--800);

          .mail-info {
            .title {
              color: var(--color-blue-gray--100);
            }

            .address {
              color: var(--color-blue-gray--100);
            }

            .avatar {
              background-image: linear-gradient(154.98deg, #303d56 6.25%, #272f3f 84.09%);
            }
          }

          .subscription {
            input {
              color: var(--color-blue-gray--300);
              background: var(--color-blue-gray--800);
              border: 1px solid var(--color-blue-gray--700);

              &::placeholder {
                color: var(--color-blue-gray--300);
              }
            }

            button {
              color: var(--color-blue-gray--900);
              background-color: var(--color-green--500);
            }
          }
        }
      }
      .ns-content {
        .logo {
          :global(.svg-wrapper svg path) {
            fill: white;
          }
        }
      }
    }
  }
</style>
